<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Configurações",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Configurações",
      settings: {},
      loading: false,
    };
  },
  methods: {
    save() {

    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">PEDIDOS</h4>
        <p class="card-title-desc">Definições sobre o controle dos pedidos recebidos</p>
        <form>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="categoryDescription">E-mails para Recebimento</label>
                <input id="categoryDescription" name="categoryDescription" type="text" class="form-control" v-model="settings.emails" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row mt-4 align-items-center">
    

      <div class="col-sm-12">
        <div class="text-sm-right">
          <b-spinner class="m-2" variant="primary" role="status" v-if="loading"></b-spinner>
          <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="save" v-if="!loading">
            <i class="mdi mdi-plus mr-1"></i> Salvar Configurações
          </button>
        </div>
      </div>

    </div>
  </Layout>
</template>
